import { SalesPerformanceData } from "@/interfaces/sales-performace.interfaces";
import { apiT2B } from "@/lib/axios";
import { BestsellingProduct } from "@/types/best-selling-product.types";

export type BestSellingProductResponse = {
  products: BestsellingProduct[];
};

class SalesDashboardService {
  private baseUrl = "api/v1/dashboard/sales";

  async orderCount(
    startDate: string,
    endDate: string
  ): Promise<{
    currentPeriodOrderCount: number;
    previousPeriodOrderCount: number;
    percentageIncrease: number;
  }> {
    const response = await apiT2B.get(
      `${this.baseUrl}/ordercount?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  }

  async totalOrderAmount(
    startDate: string,
    endDate: string
  ): Promise<{
    currentPeriodTotalOrderAmount: number;
    previousPeriodTotalOrderAmount: number;
    percentageIncrease: number;
  }> {
    const response = await apiT2B.get(
      `${this.baseUrl}/totalorderamount?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  }

  async averageOrderAmount(
    startDate: string,
    endDate: string
  ): Promise<{
    currentPeriodAverageOrderAmount: number;
    previousPeriodAverageOrderAmount: number;
    percentageIncrease: number;
  }> {
    const response = await apiT2B.get(
      `${this.baseUrl}/averageorderamount?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  }

  async bestSellingProduct(startDate: string, endDate: string): Promise<BestsellingProduct[]> {
    const response = await apiT2B.get<BestsellingProduct[]>(
      `${this.baseUrl}/bestsellingproduct?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  }

  async salesPerformance(startDate: string, endDate: string): Promise<SalesPerformanceData> {
    const response = await apiT2B.get(
      `${this.baseUrl}/salesperformance?startDate=${startDate}&endDate=${endDate}`
    );
    return response.data;
  }
}

const salesDashboardService = new SalesDashboardService();
export default salesDashboardService;
